import LoadPanel, {Position} from "devextreme-react/load-panel";

export default function LoadPopupPanel(props: { visible: boolean }) {
  return (
    <LoadPanel visible={props.visible} container={'.dx-popup-wrapper .dx-popup-content'} >
      <Position my="center" at="center" of=".dx-popup-wrapper .dx-popup-content" />
    </LoadPanel>
  )
}
